import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AreaItemPack } from '../../models/area-item-pack';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { AreaItem } from '../../models/area-item';
import { LoggerService } from '../../../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { PaymentStateService } from '../../../payment/services/payment-state.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ViewType } from '../../../general/models/view-type';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccessControlPopupComponent } from '../access-control-popup/access-control-popup.component';

@Component({
  selector: 'app-booking-packs',
  templateUrl: './booking-packs.component.html',
  styleUrls: ['./booking-packs.component.css']
})
export class BookingPacksComponent implements OnInit, OnDestroy {

  private _initialized: boolean;
  maxLenNamePack = 0;
  private subscriber: Subscription;

  constructor(
    private bookingStepService: BookingStepService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
    private bookingOrderService: BookingOrderService,
    private shopSettingsService: ShopSettingsService,
    private paymentStateService: PaymentStateService,
    private translateService: TranslateService,
    public dialog: MatDialog,
  ) { }

  ngOnDestroy(): void {
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.loadingSpinnerService.show();
    this.bookingStepService.initialize().subscribe(
      done => {
        this.initMaxSizeTitleAreaItemPack();
        this.loadingSpinnerService.hide();
        this.logger.info('BookingPacksComponent: bookingStateService initialized.');

        if (this.areaItemPacks.length === 1) {
          this.onClick(this.areaItemPacks[0]);
          return;
        }

        this._initialized = true;
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`BookingPacksComponent: bookingStateService reinitialized error: ${error.message}.`);
      }
    );
  }

  get areaItemPacks(): AreaItemPack[] {
    return this.bookingOrderService.visibleAreaItemPacks;
  }

  onClick(areaItemPack: AreaItemPack, selectedAreaItem: AreaItem = null): void {
    if (areaItemPack.accessIsAllowedOnlyFor && this.shopSettingsService.isVUMode) {
      this.accessControl(areaItemPack, selectedAreaItem);
    } else {
      this.onAreaItemPackSelected(areaItemPack, selectedAreaItem);
    }
  }

  onAreaItemPackSelected(areaItemPack: AreaItemPack, selectedAreaItem: AreaItem): void {

    if (areaItemPack.purchaseNearestTicket) {
      this.paymentStateService.reset();
    }

    this.bookingStepService.update(
      areaItemPack.purchaseNearestTicket ? BookingStepEnum.SelectNearestBookingSingleProducts : BookingStepEnum.SelectBookingPacks,
      areaItemPack,
      selectedAreaItem
    );
  }

  private accessControl(areaItemPack: AreaItemPack, selectedAreaItem: AreaItem): void {
    const dialogRef = this.showAccessControlPopUp();
    dialogRef.afterClosed().subscribe(done => {
      if (dialogRef.componentInstance.isStaffCard) {
        this.onAreaItemPackSelected(areaItemPack, selectedAreaItem);
      }
      return;
    });
  }

  private showAccessControlPopUp(): MatDialogRef<AccessControlPopupComponent> {
    return this.dialog.open(AccessControlPopupComponent);
  }

  get showSection(): boolean {
    return this._initialized;
  }

  protected initMaxSizeTitleAreaItemPack(): void {
    const packs = this.areaItemPacks;
    if (!packs || packs.length === 0) {
      return;
    }
    let maxLenPackName: number;
    let packNames: string[];
    packNames = packs.map(pack => pack.name);
    this.subscriber = this.translateService.stream(packNames).subscribe((translatePackNames) => {
      maxLenPackName = 0;
      packNames.forEach(packName => {
        const maxLen = this.getMaxSizeWord(translatePackNames[packName]);
        if (maxLen > maxLenPackName) {
          maxLenPackName = maxLen;
        }
      });
      this.maxLenNamePack = maxLenPackName;
    });
  }

  private getMaxSizeWord(str: string): number {
    if (!str) {
      return 0;
    }
    return Math.max(...str.split(' ').map(v => v.length));
  }

  get viewType(): ViewType {
    if (this.areaItemPacks !== undefined && this.areaItemPacks.length > 6) {
      return ViewType.List;
    }

    return ViewType.Buttons;
  }

  get isListMode(): boolean {
    return this.viewType === ViewType.List;
  }
}
